const businessLandingEN = {
	hero: {
		title: "Your business, growing stress-free",
		subtitle:
			"If you have a business or want to start one, Sin Fila automates bookings, reminders, and team management, while helping you attract more clients.",
		primaryCta: "Register now for free",
		storeText: "Available on iOS · Android",
		noteStrong: "Start your 14-day free trial now",
		noteRest: " • Set up your business in just 15 min • Hassle-free, no contracts • Cancel anytime",
	},

	problem: {
		title: "The real problem",
		subtitle: "Does this sound familiar?",
		items: [
			"📱 Responding to WhatsApp all day (and night)",
			"📆 Overlapping schedules or empty slots",
			"🚶 Clients arrive, see a long line… and leave",
			"📊 Not knowing how many clients you served this month",
			"🌐 Struggling to attract new clients and increase your business visibility",
		],
		itemspart2: ["⏳ If there's no customers → you lose time", "😤 If there's too much line → you lose clients."],
		description: "Every client who leaves because of the line is lost revenue.",
		highlight: "Many businesses lose up to 20% of their revenue due to poor appointment management, idle time, and clients who leave while waiting.",
	},

	didYouKnow: {
		title: "Did you know...",
		items: [
			"More than 70% of clients prefer booking online if possible",
			"Automating bookings removes WhatsApp messages all day",
			"Having online visibility helps you attract up to 40% more new clients without paying for ads",
			"Centralizing business sales data helps you make better decisions to grow",
		],
		highlight: "✅ Sin Fila organizes your schedule so you don't lose clients — and gives your business online visibility to grow.",
	},

	solution: {
		title: "Sin Fila solves it",
		points: [
			{
				title: "Never miss a booking",
				desc: "All appointments, confirmations, and reminders in one place.",
			},
			{
				title: "Attract new clients and fill your schedule",
				desc: "Show your business to more clients in our marketplace.",
			},
			{
				title: "Save time managing your shop and staff",
				desc: "Manage your services and staff calendars effortlessly.",
			},
			{
				title: "Effortless bookings for your clients",
				desc: "Clients book, modify, and get reminders automatically.",
			},
		],
	},

	businessBenefits: {
		title: "Key benefits for businesses",
		subtitle: "Organize your schedule, automate appointments, and avoid losing clients.",
		items: [
			"Receive online bookings 24/7",
			"Automatic confirmations and reminders",
			"Clear schedules with no overlaps",
			"Public profile to attract new clients",
			"Less time on WhatsApp — more time working",
		],
	},

	customerBenefits: {
		title: "Key benefits for customers",
		subtitle: "Book your appointment in seconds, without calls or waiting.",
		items: [
			"See real availability",
			"Book instantly",
			"Receive automatic reminders",
			"Reschedule or cancel stress-free",
			"Find barbershops, salons, and more near you",
		],
	},

	howToStart: {
		title: "How to start",
		steps: [
			{ title: "Create your free account", desc: "Register in minutes and set up your business." },
			{ title: "Add your services and team", desc: "Customize your profile and schedules." },
			{ title: "Start receiving bookings", desc: "And let Sin Fila do the rest." },
		],
	},

	pricing: {
		title: "A simple plan, everything included",
		planTitle: "Pay only for what you use:",
		planItems: [
			"💳 $15 USD / month — first user",
			"👥 $8 USD / month — each of your next 4 users",
			"🎁 Free for all additional users",
		],
		capNote: "Your bill no longer increases after 4 users — everyone after that is free.",
		note: "No contracts. No hidden charges. Cancel anytime.",
		autoTitle: "Paying for Sin Fila is simple and automatic:",
		autoItems: [
			"We accept credit and debit cards directly on the platform",
			"Billing happens automatically every month",
			"You can cancel anytime, no contracts or commitments",
		],
		priceNote: "14 Day free trial",
		featuresTitle: "Everything included, no matter your plan",
		features: [
			"Unlimited bookings",
			"0% commissions",
			"Personalized store on the Sin Fila marketplace",
			"Mobile app available on Apple & Android",
			"Smart calendar, zero double-bookings",
			"Effortless multi-team management",
			"In person, a domicilio & virtual bookings",
			"Personalized booking link",
			"Real-time automatic notifications",
			"Business performance reports",
			"Client contact list",
			"Revenue tracking by service, staff & source",
			"Referral program for businesses",
			"Automatic monthly billing",
			"Dedicated support",
		],
	},

	referral: {
		title: "Share Sin Fila. Get rewarded.",
		subtitle: "Know a business that needs this? Send them your code — you both come out ahead.",
		sectionLabel: "How it works",
		cards: [
			{
				icon: "💵",
				tone: "gold",
				title: "If you refer a business",
				desc: "No limit. Notricks. $15 USD credit every time someone you refer makes their first payment",
				bullets: [
					"No limit — refer as many businesses as you like, and earn $15 USD for each one.",
					"Your reward is applied automatically to your account.",
				],
			},
			{
				icon: "🎁",
				tone: "sky",
				title: "If you were referred",
				desc: "You get 2 extra weeks free — 28 days total instead of 14 — so you have more time to try Sin Fila before you're charged anything.",
			},
		],
		ctaButton: "Get my referral code",
		microCopy: "No cap. No catch. Just $15 USD every time someone you refer joins.",
		moreDetailsLink: "See full referral program details",
	},

	testimonials: {
		title: "What our clients are saying",
		items: [
			{
				quote:
					"Sin Fila has made it so much easier to organize my appointments and my day. My clients can book directly, even for at-home services, and I have everything organized in one place.",
				name: "Sara",
				role: "Wellness professional",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila has helped me keep my schedule much more organized and cut down the time I spend coordinating appointments. It also helps new clients discover me and book with me easily.",
				name: "Pedro",
				role: "Barber",
				location: "Las Terrenas",
			},
			{
				quote:
					"Sin Fila helped me organize my salon much better. Now I can see and manage my whole team's schedules from one place, and it's much easier to coordinate hours and appointments.",
				name: "Maria",
				role: "Salon owner",
				location: "Santo Domingo",
			},
		],
	},

	final: {
		text: "Register now for free, and take advantage of our referral program",
		button: "Register Now for free",
	},

	contact: {
		question: "Do you have any questions? We're here to help.",
		website: "reservasinfila.com",
		email: "hola@reservasinfila.com",
		phone: "+1 (514) 758-6041",
	},

	misc: {
  badge: "Sin Fila for business",
  freeMonthsTag: "🎁 Free months",
  labelReferral: "Referral Program",
  labelChallenge: "The Challenge",
  labelResearch: "Research",
  labelHowItWorks: "How It Works",
  labelPricing: "Pricing",
  labelTestimonials: "Testimonials",
  priceNote: "/ month per user",   // move from pricing.priceNote
},
};

export default businessLandingEN;
